// Vsebina prevzeta iz WordPress strani kupish.si (Splošni pogoji, Politika zasebnosti).
export const termsHtml = `<p>Ti splošni pogoji poslovanja so sestavljeni v skladu z veljavno zakonodajo Republike Slovenije, in sicer z:</p>

<ul>
 	<li>
<p>Zakonom o elektronskem poslovanju na trgu (ZEPT),</p>
</li>
 	<li>
<p>Zakonom o varstvu potrošnikov (ZVPot),</p>
</li>
 	<li>
<p>Obligacijskim zakonikom (OZ),</p>
</li>
 	<li>
<p>Zakonom o varstvu osebnih podatkov (ZVOP-2).</p>
</li>
</ul>
<p>Prosimo vas, da splošne pogoje poslovanja pred uporabo spletne strani in spletne trgovine skrbno preberete.</p>
<p>Splošni pogoji poslovanja urejajo delovanje spletne strani Kupish.si, pravice in obveznosti uporabnika ter poslovni odnos med posameznim prodajalcem in kupcem. Uporabnika zavezujejo pogoji, ki so veljavni v trenutku oddaje naročila. S potrditvijo naročila uporabnik potrjuje, da je seznanjen s pogoji poslovanja, pravnim obvestilom ter <a class="decorated-link" href="https://kupish.si/pravila-zasebnosti/" rel="noopener">Pravili zasebnosti</a>.</p>
<p>Spletno stran <strong><a class="decorated-link" href="http://www.kupish.si" rel="noopener">www.kupish.si</a></strong> upravlja podjetje <strong>Artepin d.o.o.</strong>, Šišenska cesta 17, 1000 Ljubljana, matična številka: 8626324000, davčna številka: 49460315. Artepin d.o.o. nastopa kot <strong>upravljavec platforme</strong>, posamezni prodajalci pa so ponudniki izdelkov in storitev, objavljenih na strani.</p>

<hr />

<h2>1. Registracija in postopek nakupa</h2>
<p>Registracija uporabnika ni obvezna. Naročilo je možno oddati brez registracije, pri čemer se lahko cene za registrirane in neregistrirane uporabnike razlikujejo.</p>
<p>Za izvedbo naročila je obvezen vnos osebnih podatkov (ime, priimek, naslov, e-poštni naslov) ter izbor načina dostave. V primeru nakupa podjetja je obvezen tudi naziv podjetja in davčna številka.</p>
<p>Postopek nakupa poteka prek košarice v treh korakih:</p>

<ol>
 	<li>
<p>izbira izdelkov,</p>
</li>
 	<li>
<p>vnos podatkov in način dostave,</p>
</li>
 	<li>
<p>povzetek in potrditev naročila.</p>
</li>
</ol>
<p>Naročilo je potrjeno s klikom na gumb »Potrditev naročila«. Po potrditvi naročila bo kupec na elektronski naslov prejel obvestilo s podrobnostmi naročila in navodili za plačilo.</p>

<hr />

<h2>2. Cene</h2>
<p>Vse cene so izražene v evrih (EUR) in, kjer je to navedeno, vključujejo DDV.</p>
<p>Cene veljajo v trenutku oddaje naročila in nimajo vnaprej določene veljavnosti, razen v primeru akcij, kjer je trajanje posebej navedeno.</p>
<p>Kljub prizadevanjem za točnost lahko pride do napak pri prikazu cen ali lastnosti izdelkov. V takem primeru bo prodajalec kupca obvestil ter mu omogočil odstop od naročila ali spremembo.</p>
<p>Kupoprodajna pogodba je sklenjena, ko prodajalec potrdi naročilo.</p>

<hr />

<h2>3. Plačilo in račun</h2>
<p>Načini plačila so:</p>

<ul>
 	<li>
<p>plačilo po predračunu,</p>
</li>
 	<li>
<p>plačilo po povzetju.</p>
</li>
</ul>
<p>Rok za plačilo po predračunu je 8 dni od prejema predračuna.</p>
<p>Kupec prejme originalni račun:</p>

<ul>
 	<li>
<p>priložen k pošiljki,</p>
</li>
 	<li>
<p>ob osebnem prevzemu,</p>
</li>
 	<li>
<p>ali kot e-račun (pri naročilih javnega sektorja).</p>
</li>
</ul>

<hr />

<h2>4. Dostava</h2>
<p>Dostavo izvajajo prodajalci preko Pošte Slovenije ali drugih dostavnih služb. Stroški dostave niso vključeni v ceno izdelka in so kupcu znani pred potrditvijo naročila.</p>
<p>Kupec lahko pri oddaji naročila navede dodatne opombe glede dostave. Po dogovoru je možen tudi osebni prevzem.</p>

<hr />

<h2>5. Pravica do odstopa od pogodbe</h2>
<p>Kupec (potrošnik) lahko v 14 dneh od prejema blaga ponudniku pisno sporoči, da odstopa od pogodbe, brez navedbe razloga.</p>
<p>Ker Kupish.si združuje več prodajalcev, je kupec dolžan <strong>pred vračilom izdelka neposredno kontaktirati prodajalca</strong>, od katerega je izdelek kupil. Kontaktni podatki vsakega prodajalca so navedeni ob izdelku in/ali v potrditvenem sporočilu naročila.</p>
<p>Stroške vračila krije kupec, razen če prodajalec določi drugače. Pošiljk z odkupnino prodajalci ne sprejemajo. Vračilo plačila mora biti izvedeno v 14 dneh po prejemu vrnjenega blaga.</p>

<hr />

<h2>6. Reklamacije</h2>
<p>Za reklamacije je odgovoren posamezni prodajalec, od katerega je kupec kupil izdelek.</p>
<p>Kupec mora reklamacijo vložiti pisno na kontakt prodajalca, priložiti račun in opisati razlog reklamacije. Prodajalec je dolžan reklamacijo obravnavati v razumnem roku in kupcu omogočiti ustrezno rešitev (popravilo, zamenjavo, vračilo kupnine).</p>

<hr />

<h2>7. Varnost</h2>
<p>Artepin d.o.o. in prodajalci uporabljajo ustrezne tehnične in organizacijske ukrepe za zaščito podatkov, naročil in plačil.</p>

<hr />

<h2>8. Varstvo osebnih podatkov</h2>
<p>Ponudnik in prodajalci varujejo osebne podatke skladno z ZVOP-2 in GDPR.</p>
<p>Osebni podatki se uporabljajo izključno za potrebe izpolnitve naročila in dostave. Podrobnosti so opredeljene v dokumentu <a class="decorated-link" href="https://kupish.si/pravila-zasebnosti/" rel="noopener">Pravila zasebnosti</a>.</p>

<hr />

<h2>9. Odveza odgovornosti</h2>
<p>Artepin d.o.o. kot upravljavec platforme ne odgovarja za točnost podatkov in vsebin, ki jih vnesejo posamezni prodajalci. Prav tako ne odgovarja za morebitno škodo, nastalo pri uporabi spletne strani.</p>
<p>Slike izdelkov so simbolične in ne zagotavljajo nujno dejanskih lastnosti izdelka.</p>

<hr />

<h2>10. Pravno obvestilo</h2>
<p>Vsebina spletne strani je last Artepin d.o.o. Podjetje si pridržuje pravico do sprememb vsebine in cen brez predhodnega obvestila.</p>

<hr />

<h2>11. Pritožbe in spori</h2>
<p>Pritožbe lahko kupec naslovi neposredno na prodajalca ali na upravljavca platforme na naslov:<br /><strong>Artepin d.o.o., Šišenska cesta 17, 1000 Ljubljana, e-pošta: <a class="decorated-link cursor-pointer" rel="noopener">info@kupish.si</a></strong>.</p>
<p>Pritožba bo potrjena najkasneje v 8 delovnih dneh, kupec pa bo obveščen o poteku postopka.</p>
<p>Za sodno reševanje sporov je pristojno sodišče v Ljubljani.</p>
<p>Potrošniki imajo možnost reševanja sporov tudi preko <strong>platforme za spletno reševanje sporov (SRPS/ODR)</strong>: <a class="decorated-link cursor-pointer" rel="noopener">https://ec.europa.eu/odr</a>.</p>

<hr />

<h2>12. Najem prodajnega mesta za prodajalce</h2>
<p>Prodajalci na spletni strani Kupish.si najamejo prodajno mesto (spletno trgovino) pri upravljavcu platforme. Najemnina znaša <strong>240 € letno</strong> in vključuje objavo profila prodajalca, objavo do 100 izdelkov, gostovanje, vzdrževanje in promocijo nakupovalnega središča. Upravljavec od prodaje ne zaračunava provizije.</p>
<p><strong>Brezplačni preizkus:</strong> novo prijavljeni prodajalci imajo <strong>3 mesece brezplačnega dostopa</strong> od registracije trgovine. Prodajalci, ki so bili na platformi prijavljeni pred uvedbo teh pogojev, imajo <strong>6 mesecev brezplačnega dostopa</strong>. Po izteku brezplačnega obdobja se za nadaljnjo objavo trgovine plača letna najemnina; če najemnina ni poravnana, se trgovina in njeni izdelki umaknejo iz javne objave, podatki pa ostanejo shranjeni.</p>
<p>Prodajalec sam določa cene, zaloge, pogoje dostave in poštnino ter kot prodajalec odgovarja za izdajo računa, garancijo, vračila in reklamacije. Upravljavec platforme zagotavlja tehnično delovanje strani in posreduje naročila ter povpraševanja.</p>

<hr />

<h2>13. Upravljavec spletne strani</h2>
<p><strong>Artepin d.o.o.</strong><br />Šišenska cesta 17, 1000 Ljubljana<br />Matična številka: 8626324000<br />Davčna številka: 49460315<br />Telefon: 070 783641<br />E-pošta: <a class="decorated-link cursor-pointer" rel="noopener">info@kupish.si</a></p>

<hr />
<p><strong>Veljavnost:</strong> Ti splošni pogoji so veljavni od 8. 9. 2026 dalje. Upravljavec si pridržuje pravico do sprememb pogojev, pri čemer bodo uporabniki o tem obveščeni na spletni strani.</p>`;

export const privacyHtml = `<h1 class="wp-block-heading"><strong>Politika zasebnosti in piškotkov – Kupish.si</strong></h1>

<h2 class="wp-block-heading">1. Uvod</h2>

<p>Ta politika zasebnosti pojasnjuje, kako se obdelujejo osebni podatki uporabnikov spletne strani <strong><a href="http://www.kupish.si">www.kupish.si</a></strong>.<br />Upravljavec platforme je <strong>Artepin d.o.o., Šišenska cesta 17, 1000 Ljubljana, e-pošta: <a>info@kupish.si</a></strong>.</p>

<p>Ker Kupish.si omogoča prodajo več različnim prodajalcem, je vsak prodajalec odgovoren za obdelavo osebnih podatkov kupcev, ki pri njem opravijo nakup. Artepin d.o.o. obdeluje podatke le v obsegu, potrebnem za delovanje platforme.</p>

<hr class="wp-block-separator has-alpha-channel-opacity" />

<h2 class="wp-block-heading">2. Katere podatke zbiramo</h2>

<p>Pri uporabi spletne strani in oddaji naročila se lahko zbirajo naslednji osebni podatki:</p>

<ul>
<li style="list-style-type: none;">
<ul>
<li>ime in priimek,</li>

<li>naslov za dostavo in račun,</li>

<li>e-poštni naslov in telefonska številka,</li>

<li>podatki o podjetju (naziv, davčna številka – kadar gre za pravne osebe),</li>

<li>zgodovina naročil in komunikacije s prodajalcem,</li>

<li>podatki o načinu plačila.</li>
</ul>
</li>
</ul>

<p>Ob obisku spletne strani se samodejno zbirajo tudi podatki prek piškotkov (npr. IP-naslov, vrsta brskalnika, čas obiska, obiskanih strani).</p>

<hr class="wp-block-separator has-alpha-channel-opacity" />

<h2 class="wp-block-heading">3. Namen obdelave osebnih podatkov</h2>

<p>Osebni podatki se obdelujejo za naslednje namene:</p>

<ul>
<li style="list-style-type: none;">
<ul>
<li>izvedba naročila in dostava izdelkov,</li>

<li>izdaja računa,</li>

<li>komunikacija s kupcem glede naročila,</li>

<li>reševanje reklamacij in pritožb,</li>

<li>izpolnjevanje zakonskih obveznosti (npr. davčna zakonodaja),</li>

<li>neposredno trženje podobnih izdelkov ali storitev, če kupec temu ni ugovarjal.</li>
</ul>
</li>
</ul>

<hr class="wp-block-separator has-alpha-channel-opacity" />

<h2 class="wp-block-heading">4. Pravna podlaga obdelave</h2>

<p>Osebne podatke obdelujemo na naslednjih pravnih podlagah:</p>

<ul>
<li style="list-style-type: none;">
<ul>
<li>sklenitev in izvajanje pogodbe (nakup izdelkov),</li>

<li>zakonska obveznost (izdaja računov),</li>

<li>zakoniti interes (osnovna statistika, izboljšanje uporabniške izkušnje),</li>

<li>privolitev uporabnika (piškotki za analitiko in marketing).</li>
</ul>
</li>
</ul>

<hr class="wp-block-separator has-alpha-channel-opacity" />

<h2 class="wp-block-heading">5. Hramba podatkov</h2>

<p>Osebni podatki se hranijo:</p>

<ul>
<li style="list-style-type: none;">
<ul>
<li>toliko časa, kolikor je potrebno za izpolnitev namena, zaradi katerega so bili zbrani,</li>

<li>podatki na računih se hranijo skladno z davčno zakonodajo (10 let),</li>

<li>podatki za trženje se hranijo do preklica privolitve oziroma zahteve za izbris.</li>
</ul>
</li>
</ul>

<hr class="wp-block-separator has-alpha-channel-opacity" />

<h2 class="wp-block-heading">6. Posredovanje podatkov tretjim osebam</h2>

<p>Osebni podatki se posredujejo tretjim osebam samo, kadar je to nujno potrebno:</p>

<ul>
<li style="list-style-type: none;">
<ul>
<li>dostavnim službam za dostavo naročil,</li>

<li>računovodskim in pravnim servisom (če je to potrebno zaradi zakonskih obveznosti),</li>

<li>IT ponudnikom, ki skrbijo za delovanje spletne strani.</li>
</ul>
</li>
</ul>

<p>Podatki se ne posredujejo tretjim osebam za namene trženja brez izrecne privolitve uporabnika.</p>

<hr class="wp-block-separator has-alpha-channel-opacity" />

<h2 class="wp-block-heading">7. Pravice uporabnikov</h2>

<p>Uporabniki imajo skladno z GDPR naslednje pravice:</p>

<ul>
<li style="list-style-type: none;">
<ul>
<li>pravico do dostopa do podatkov,</li>

<li>pravico do popravka netočnih podatkov,</li>

<li>pravico do izbrisa podatkov (“pravica do pozabe”),</li>

<li>pravico do omejitve obdelave,</li>

<li>pravico do prenosljivosti podatkov,</li>

<li>pravico do ugovora obdelavi.</li>
</ul>
</li>
</ul>

<p>Zahtevo lahko posredujete na e-naslov: <strong><a>info@kupish.si</a></strong>.</p>

<p>Če menite, da so vaše pravice kršene, se lahko obrnete na <strong>Informacijskega pooblaščenca RS</strong> (<a>gp.ip@ip-rs.si</a>).</p>

<hr class="wp-block-separator has-alpha-channel-opacity" />

<h2 class="wp-block-heading">8. Piškotki</h2>

<p>Spletna stran uporablja piškotke, ki so majhne datoteke, shranjene na vašem računalniku. Delimo jih na:</p>

<ul>
<li style="list-style-type: none;">
<ul>
<li><strong>Nujne piškotke</strong> – potrebni za delovanje strani (npr. košarica, prijava).</li>

<li><strong>Analitične piškotke</strong> – zbirajo anonimne podatke o uporabi strani (npr. Google Analytics).</li>

<li><strong>Marketinške piškotke</strong> – omogočajo prikazovanje personaliziranih oglasov.</li>
</ul>
</li>
</ul>

<p>Uporabnik lahko piškotke kadarkoli izbriše ali onemogoči v nastavitvah brskalnika. Če nujne piškotke onemogočite, uporaba spletne trgovine ne bo mogoča.</p>

<hr class="wp-block-separator has-alpha-channel-opacity" />

<h2 class="wp-block-heading">9. Varovanje podatkov</h2>

<p>Artepin d.o.o. in prodajalci uporabljajo ustrezne tehnične in organizacijske ukrepe za zaščito osebnih podatkov pred izgubo, zlorabo ali nepooblaščenim dostopom.</p>

<hr class="wp-block-separator has-alpha-channel-opacity" />

<h2 class="wp-block-heading">10. Spremembe politike zasebnosti</h2>

<p>Politika zasebnosti se lahko občasno spremeni. Veljavna verzija bo vedno objavljena na spletni strani Kupish.si.</p>

<hr class="wp-block-separator has-alpha-channel-opacity" />
<p><strong>Veljavnost:</strong> Ta politika velja od 8. 9. 2026 dalje.</p>`;
